export const FETCH_ITEM_DETAILS_BEGIN = 'FETCH_ITEM_DETAILS_BEGIN';
export const FETCH_ITEM_DETAILS_SUCCESS = 'FETCH_ITEM_DETAILS_SUCCESS';
export const FETCH_ITEM_DETAILS_FAILURE = 'FETCH_ITEM_DETAILS_FAILURE';
export const FETCH_ITEM_DETAILS_DISMISS_ERROR = 'FETCH_ITEM_DETAILS_DISMISS_ERROR';
export const IA_STI_INQUIRY_RESET_ITEM_DETAILS = 'IA_STI_INQUIRY_RESET_ITEM_DETAILS';

export const FETCH_SHIP_TO_DETAILS_BEGIN = 'FETCH_SHIP_TO_DETAILS_BEGIN';
export const FETCH_SHIP_TO_DETAILS_SUCCESS = 'FETCH_SHIP_TO_DETAILS_SUCCESS';
export const FETCH_SHIP_TO_DETAILS_FAILURE = 'FETCH_SHIP_TO_DETAILS_FAILURE';
export const FETCH_SHIP_TO_DETAILS_DISMISS_ERROR = 'FETCH_SHIP_TO_DETAILS_DISMISS_ERROR';
export const IA_STI_INQUIRY_RESET_SHIP_TO_DETAILS = 'IA_STI_INQUIRY_RESET_SHIP_TO_DETAILS';

export const IA_STI_FETCH_SITE_INFO_BEGIN = 'IA_STI_FETCH_SITE_INFO_BEGIN';
export const IA_STI_FETCH_SITE_INFO_SUCCESS = 'IA_STI_FETCH_SITE_INFO_SUCCESS';
export const IA_STI_FETCH_SITE_INFO_FAILURE = 'IA_STI_FETCH_SITE_INFO_FAILURE';
export const IA_STI_FETCH_SITE_INFO_DISMISS_ERROR = 'IA_STI_FETCH_SITE_INFO_DISMISS_ERROR';


